<!-- Category Picker Builder -->

<template>
	<div class="bld-cat-pick-main">
		<div class="title wi8_font">Category Picker Builder (cat: {{current.cat.title}})</div>

		<CatPick />

	</div>
</template>

<script>
import { mapState } from 'vuex';
import CatPick from "@/components/CatPick.vue"
export default {
	components: {
		CatPick,
	},
	computed: {
		...mapState('app', ['current']),
	},
}
</script>

<style scoped>
	.bld-cat-pick-main {
		height: 100%;
		overflow: hidden;
		background-color: #FCFCEE;
		padding: 5px;
		border: solid 1px #009;
	}
	.title {
		color: #090;
	}
</style>
